"use client";

import { c as _c } from "react/compiler-runtime";
import { Col } from "react-bootstrap";
import styles from "../NFTImage.module.scss";
import NFTImageBalance from "../NFTImageBalance";
import { BaseRendererProps } from "../types/renderer-props";
export default function NFTVideoRenderer(props) {
  const $ = _c(16);
  const t0 = `${styles.nftAnimation} ${props.heightStyle} ${props.bgStyle} d-flex justify-content-center align-items-center`;
  let t1;
  if ($[0] !== props.height || $[1] !== props.nft.contract || $[2] !== props.nft.id || $[3] !== props.showBalance) {
    t1 = props.showBalance && <NFTImageBalance contract={props.nft.contract} tokenId={props.nft.id} height={props.height} />;
    $[0] = props.height;
    $[1] = props.nft.contract;
    $[2] = props.nft.id;
    $[3] = props.showBalance;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const t2 = props.id ?? `video-${props.nft.id}`;
  const t3 = !props.showOriginal && "metadata" in props.nft && props.nft.compressed_animation ? props.nft.compressed_animation : props.nft.animation;
  let t4;
  if ($[5] !== props.nft) {
    t4 = t5 => {
      const {
        currentTarget
      } = t5;
      if ("metadata" in props.nft && currentTarget.src === props.nft.compressed_animation) {
        currentTarget.src = props.nft.animation;
      } else {
        if ("metadata" in props.nft) {
          currentTarget.src = props.nft.metadata.animation;
        }
      }
    };
    $[5] = props.nft;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== props.imageStyle || $[8] !== t2 || $[9] !== t3 || $[10] !== t4) {
    t5 = <video id={t2} autoPlay={true} muted={true} controls={true} loop={true} playsInline={true} preload="auto" src={t3} className={props.imageStyle} onError={t4} />;
    $[7] = props.imageStyle;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t0 || $[13] !== t1 || $[14] !== t5) {
    t6 = <Col className={t0}>{t1}{t5}</Col>;
    $[12] = t0;
    $[13] = t1;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}